export const filterProductOptionsByMarket = (
	queues,
	productOptions,
	marketId,
) => {
	if (!queues || !productOptions || !marketId) {
		return [];
	}
	const productIdsFromQueues = queues
		.filter((queue) => {
			return queue.market === marketId;
		})
		.map((q) => q.product);

	return productOptions.filter((productOption) => {
		return productIdsFromQueues.includes(productOption.value);
	});
};
